<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    v-if="name === 'plus-circle'"
  >
    <path
      d="M9.33334 14H14M14 14H18.6667M14 14V18.6666M14 14V9.33331"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <circle
      cx="14"
      cy="14"
      r="10.5"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    v-if="name === 'download'"
  >
    <path
      d="M7 12L12 17M12 17L17 12M12 17L12 4"
      stroke="#313030"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6 20H18"
      stroke="#313030"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="4"
    viewBox="0 0 16 4"
    fill="none"
    v-if="name === 'three-dot'"
  >
    <path
      d="M10 2C10 3.10457 9.10457 4 8 4C6.89543 4 6 3.10457 6 2C6 0.895431 6.89543 0 8 0C9.10457 0 10 0.895431 10 2Z"
      fill="#313030"
    />
    <path
      d="M16 2C16 3.10457 15.1046 4 14 4C12.8954 4 12 3.10457 12 2C12 0.895431 12.8954 0 14 0C15.1046 0 16 0.895431 16 2Z"
      fill="#313030"
    />
    <path
      d="M4 2C4 3.10457 3.10457 4 2 4C0.895431 4 0 3.10457 0 2C0 0.895431 0.895431 0 2 0C3.10457 0 4 0.895431 4 2Z"
      fill="#313030"
    />
  </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    v-if="name === 'edit'"
  >
    <path
      d="M11 5H4.77778C4.30628 5 3.8541 5.1873 3.5207 5.5207C3.1873 5.8541 3 6.30628 3 6.77778V19.2222C3 19.6937 3.1873 20.1459 3.5207 20.4793C3.8541 20.8127 4.30628 21 4.77778 21H17.2222C17.6937 21 18.1459 20.8127 18.4793 20.4793C18.8127 20.1459 19 19.6937 19 19.2222V13"
      stroke="#313030"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M17.6662 3.57198C18.0325 3.20575 18.5292 3 19.0471 3C19.5651 3 20.0618 3.20575 20.428 3.57198C20.7943 3.93822 21 4.43494 21 4.95287C21 5.47081 20.7943 5.96753 20.428 6.33376L11.6824 15.0794L8 16L8.92059 12.3176L17.6662 3.57198Z"
      stroke="#313030"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    v-if="name === 'send'"
  >
    <path
      d="M10.3076 13.6923L15.1538 8.84619"
      stroke="#313030"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3.2326 10.27C2.42568 9.86652 2.52346 8.68509 3.38572 8.41978L19.1948 3.55543C19.9621 3.31935 20.6808 4.03802 20.4447 4.8053L15.5804 20.6144C15.315 21.4767 14.1336 21.5745 13.7302 20.7675L10.38 14.0673C10.2833 13.8738 10.1264 13.7169 9.93283 13.6201L3.2326 10.27Z"
      stroke="#313030"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    v-if="name === 'garbage'"
  >
    <path
      d="M8.57143 7V4.8C8.57143 4.32261 8.75204 3.86477 9.07353 3.52721C9.39502 3.18964 9.83106 3 10.2857 3H13.7143C14.1689 3 14.605 3.18964 14.9265 3.52721C15.248 3.86477 15.4286 4.32261 15.4286 4.8V7M19 7L18 19.2C18 19.6774 17.8194 20.1352 17.4979 20.4728C17.1764 20.8104 16.7404 21 16.2857 21H7.71429C7.25963 21 6.82359 20.8104 6.5021 20.4728C6.18061 20.1352 6 19.6774 6 19.2L5 7H19Z"
      stroke="#313030"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4 7H5.77778H20"
      stroke="#313030"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10 11V16"
      stroke="#313030"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14 11V16"
      stroke="#313030"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    v-if="name === 'arrow-back'"
  >
    <path
      d="M16 6.66675L6.66666 16.0001M6.66666 16.0001L16 25.3334M6.66666 16.0001H25.3333"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="53"
    height="53"
    viewBox="0 0 53 53"
    fill="none"
    v-if="name === 'track'"
  >
    <circle cx="26.25" cy="26.25" r="26.25" fill="#313030" />
    <path
      d="M27.2794 39.375L37.1875 15.3125L13.125 25.2206L22.2978 29.1518C22.7698 29.3541 23.1459 29.7302 23.3482 30.2022L27.2794 39.375Z"
      stroke="white"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    v-if="name === 'chevron-left'"
  >
    <path
      d="M15 19L8 12L15 5"
      stroke="#14181F"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    width="53"
    height="53"
    viewBox="0 0 53 53"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    v-if="name === 'center-button'"
  >
    <circle cx="26.25" cy="26.25" r="26.25" fill="#313030" />
    <path
      d="M26 30C24.9 30 23.9583 29.6083 23.175 28.825C22.3917 28.0417 22 27.1 22 26C22 24.9 22.3917 23.9583 23.175 23.175C23.9583 22.3917 24.9 22 26 22C27.1 22 28.0417 22.3917 28.825 23.175C29.6083 23.9583 30 24.9 30 26C30 27.1 29.6083 28.0417 28.825 28.825C28.0417 29.6083 27.1 30 26 30ZM26 28C26.55 28 27.021 27.8043 27.413 27.413C27.805 27.0217 28.0007 26.5507 28 26C28 25.45 27.8043 24.9793 27.413 24.588C27.0217 24.1967 26.5507 24.0007 26 24C25.45 24 24.9793 24.196 24.588 24.588C24.1967 24.98 24.0007 25.4507 24 26C24 26.55 24.196 27.021 24.588 27.413C24.98 27.805 25.4507 28.0007 26 28ZM19 35C18.45 35 17.9793 34.8043 17.588 34.413C17.1967 34.0217 17.0007 33.5507 17 33V29H19V33H23V35H19ZM29 35V33H33V29H35V33C35 33.55 34.8043 34.021 34.413 34.413C34.0217 34.805 33.5507 35.0007 33 35H29ZM17 23V19C17 18.45 17.196 17.9793 17.588 17.588C17.98 17.1967 18.4507 17.0007 19 17H23V19H19V23H17ZM33 23V19H29V17H33C33.55 17 34.021 17.196 34.413 17.588C34.805 17.98 35.0007 18.4507 35 19V23H33Z"
      fill="white"
    />
  </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    v-if="name === 'cog'"
  >
    <path
      d="M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z"
      stroke="#14181F"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.7273 14.7273C18.6063 15.0015 18.5702 15.3056 18.6236 15.6005C18.6771 15.8954 18.8177 16.1676 19.0273 16.3818L19.0818 16.4364C19.2509 16.6052 19.385 16.8057 19.4765 17.0265C19.568 17.2472 19.6151 17.4838 19.6151 17.7227C19.6151 17.9617 19.568 18.1983 19.4765 18.419C19.385 18.6397 19.2509 18.8402 19.0818 19.0091C18.913 19.1781 18.7124 19.3122 18.4917 19.4037C18.271 19.4952 18.0344 19.5423 17.7955 19.5423C17.5565 19.5423 17.3199 19.4952 17.0992 19.4037C16.8785 19.3122 16.678 19.1781 16.5091 19.0091L16.4545 18.9545C16.2403 18.745 15.9682 18.6044 15.6733 18.5509C15.3784 18.4974 15.0742 18.5335 14.8 18.6545C14.5311 18.7698 14.3018 18.9611 14.1403 19.205C13.9788 19.4489 13.8921 19.7347 13.8909 20.0273V20.1818C13.8909 20.664 13.6994 21.1265 13.3584 21.4675C13.0174 21.8084 12.5549 22 12.0727 22C11.5905 22 11.1281 21.8084 10.7871 21.4675C10.4461 21.1265 10.2545 20.664 10.2545 20.1818V20.1C10.2475 19.7991 10.1501 19.5073 9.97501 19.2625C9.79991 19.0176 9.55521 18.8312 9.27273 18.7273C8.99853 18.6063 8.69437 18.5702 8.39947 18.6236C8.10456 18.6771 7.83244 18.8177 7.61818 19.0273L7.56364 19.0818C7.39478 19.2509 7.19425 19.385 6.97353 19.4765C6.7528 19.568 6.51621 19.6151 6.27727 19.6151C6.03834 19.6151 5.80174 19.568 5.58102 19.4765C5.36029 19.385 5.15977 19.2509 4.99091 19.0818C4.82186 18.913 4.68775 18.7124 4.59626 18.4917C4.50476 18.271 4.45766 18.0344 4.45766 17.7955C4.45766 17.5565 4.50476 17.3199 4.59626 17.0992C4.68775 16.8785 4.82186 16.678 4.99091 16.5091L5.04545 16.4545C5.25503 16.2403 5.39562 15.9682 5.4491 15.6733C5.50257 15.3784 5.46647 15.0742 5.34545 14.8C5.23022 14.5311 5.03887 14.3018 4.79497 14.1403C4.55107 13.9788 4.26526 13.8921 3.97273 13.8909H3.81818C3.33597 13.8909 2.87351 13.6994 2.53253 13.3584C2.19156 13.0174 2 12.5549 2 12.0727C2 11.5905 2.19156 11.1281 2.53253 10.7871C2.87351 10.4461 3.33597 10.2545 3.81818 10.2545H3.9C4.2009 10.2475 4.49273 10.1501 4.73754 9.97501C4.98236 9.79991 5.16883 9.55521 5.27273 9.27273C5.39374 8.99853 5.42984 8.69437 5.37637 8.39947C5.3229 8.10456 5.18231 7.83244 4.97273 7.61818L4.91818 7.56364C4.74913 7.39478 4.61503 7.19425 4.52353 6.97353C4.43203 6.7528 4.38493 6.51621 4.38493 6.27727C4.38493 6.03834 4.43203 5.80174 4.52353 5.58102C4.61503 5.36029 4.74913 5.15977 4.91818 4.99091C5.08704 4.82186 5.28757 4.68775 5.50829 4.59626C5.72901 4.50476 5.96561 4.45766 6.20455 4.45766C6.44348 4.45766 6.68008 4.50476 6.9008 4.59626C7.12152 4.68775 7.32205 4.82186 7.49091 4.99091L7.54545 5.04545C7.75971 5.25503 8.03183 5.39562 8.32674 5.4491C8.62164 5.50257 8.9258 5.46647 9.2 5.34545H9.27273C9.54161 5.23022 9.77093 5.03887 9.93245 4.79497C10.094 4.55107 10.1807 4.26526 10.1818 3.97273V3.81818C10.1818 3.33597 10.3734 2.87351 10.7144 2.53253C11.0553 2.19156 11.5178 2 12 2C12.4822 2 12.9447 2.19156 13.2856 2.53253C13.6266 2.87351 13.8182 3.33597 13.8182 3.81818V3.9C13.8193 4.19253 13.906 4.47834 14.0676 4.72224C14.2291 4.96614 14.4584 5.15749 14.7273 5.27273C15.0015 5.39374 15.3056 5.42984 15.6005 5.37637C15.8954 5.3229 16.1676 5.18231 16.3818 4.97273L16.4364 4.91818C16.6052 4.74913 16.8057 4.61503 17.0265 4.52353C17.2472 4.43203 17.4838 4.38493 17.7227 4.38493C17.9617 4.38493 18.1983 4.43203 18.419 4.52353C18.6397 4.61503 18.8402 4.74913 19.0091 4.91818C19.1781 5.08704 19.3122 5.28757 19.4037 5.50829C19.4952 5.72901 19.5423 5.96561 19.5423 6.20455C19.5423 6.44348 19.4952 6.68008 19.4037 6.9008C19.3122 7.12152 19.1781 7.32205 19.0091 7.49091L18.9545 7.54545C18.745 7.75971 18.6044 8.03183 18.5509 8.32674C18.4974 8.62164 18.5335 8.9258 18.6545 9.2V9.27273C18.7698 9.54161 18.9611 9.77093 19.205 9.93245C19.4489 10.094 19.7347 10.1807 20.0273 10.1818H20.1818C20.664 10.1818 21.1265 10.3734 21.4675 10.7144C21.8084 11.0553 22 11.5178 22 12C22 12.4822 21.8084 12.9447 21.4675 13.2856C21.1265 13.6266 20.664 13.8182 20.1818 13.8182H20.1C19.8075 13.8193 19.5217 13.906 19.2778 14.0676C19.0339 14.2291 18.8425 14.4584 18.7273 14.7273Z"
      stroke="#14181F"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    v-if="name === 'users'"
  >
    <path
      d="M17 16.2275C19.3304 16.7767 21 18.2583 21 19.9999"
      :stroke="fill"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3 20C3 17.7909 5.68629 16 9 16C12.3137 16 15 17.7909 15 20"
      :stroke="fill"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M15 13C17.2091 13 19 11.2091 19 9C19 6.79086 17.2091 5 15 5"
      :stroke="fill"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M9 13C11.2091 13 13 11.2091 13 9C13 6.79086 11.2091 5 9 5C6.79086 5 5 6.79086 5 9C5 11.2091 6.79086 13 9 13Z"
      :stroke="fill"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    v-if="name === 'marker'"
  >
    <circle cx="12" cy="11" r="2" :stroke="fill" stroke-width="2" />
    <path
      d="M12 22.0001L17.5 16.5001C20.5376 13.4625 20.5376 8.53766 17.5 5.5001C14.4624 2.46253 9.53757 2.46253 6.5 5.5001C3.46244 8.53766 3.46244 13.4625 6.5 16.5001L12 22.0001Z"
      :stroke="fill"
      stroke-width="2"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    v-if="name === 'signout'"
  >
    <path
      d="M18.365 5.64014C19.6234 6.89893 20.4803 8.50258 20.8273 10.2483C21.1743 11.9941 20.9959 13.8035 20.3146 15.4479C19.6334 17.0923 18.4798 18.4977 16.9998 19.4865C15.5199 20.4753 13.7799 21.0031 12 21.0031C10.2201 21.0031 8.48016 20.4753 7.00018 19.4865C5.5202 18.4977 4.36664 17.0923 3.68537 15.4479C3.00409 13.8035 2.82569 11.9941 3.17272 10.2483C3.51975 8.50258 4.37663 6.89893 5.635 5.64014"
      stroke="#313030"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M12 3V12"
      stroke="#313030"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    v-if="name === 'chevron-down'"
  >
    <path
      d="M7 10L12 15L17 10"
      stroke="#313030"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    v-if="name === 'update'"
  >
    <path
      d="M21 11.9998C21 7.02919 16.9706 2.99976 12 2.99976C9.17273 2.99976 6.64996 4.30342 5 6.34242"
      :stroke="fill"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M4.5 2.99976L4.5 6.99976L8.5 6.99976"
       :stroke="fill"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3 11.9998C3 16.9703 7.02944 20.9998 12 20.9998C14.8273 20.9998 17.35 19.6961 19 17.6571"
       :stroke="fill"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M19.5 20.9998L19.5 16.9998L15.5 16.9998"
       :stroke="fill"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    v-if="name === 'close'"
  >
    <path
      d="M18 18L6 6"
      stroke="#313030"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18 6L5.99994 18"
      stroke="#313030"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    v-if="name === 'not-accessible'"
  >
    <path
      d="M10 8L14 12M14 8L10 12M12.56 20.82C12.3966 20.9366 12.2008 20.9993 12 20.9993C11.7992 20.9993 11.6035 20.9366 11.44 20.82C6.61102 17.378 1.48602 10.298 6.66702 5.182C8.08888 3.78212 10.0047 2.99826 12 3C14 3 15.919 3.785 17.333 5.181C22.514 10.297 17.389 17.376 12.56 20.82Z"
      stroke="#E6653D"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    v-if="name === 'itinerary'"
  >
    <path
      d="M15.5 21.5V19.192L8.115 15.5H3.5V10.5H7.53L10.5 7.092V2.5H15.5V7.5H11.47L8.5 10.908V14.558L15.5 18.058V16.5H20.5V21.5H15.5ZM11.5 6.5H14.5V3.5H11.5V6.5ZM4.5 14.5H7.5V11.5H4.5V14.5ZM16.5 20.5H19.5V17.5H16.5V20.5Z"
      :fill="fill"
    />
  </svg>
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" v-if="name === 'arrow'">
    <g clip-path="url(#clip0_203_2)">
    <path d="M13.06 3.28304C12.7787 3.00214 12.3975 2.84436 12 2.84436C11.6025 2.84436 11.2212 3.00214 10.94 3.28304L5.28097 8.93904C4.99958 9.22044 4.84149 9.60209 4.84149 10C4.84149 10.398 4.99958 10.7796 5.28097 11.061C5.56237 11.3424 5.94402 11.5005 6.34197 11.5005C6.73992 11.5005 7.12158 11.3424 7.40297 11.061L10.5 7.96504V19.5C10.5 19.8979 10.658 20.2794 10.9393 20.5607C11.2206 20.842 11.6021 21 12 21C12.3978 21 12.7793 20.842 13.0606 20.5607C13.3419 20.2794 13.5 19.8979 13.5 19.5V7.96504L16.596 11.061C16.7353 11.2004 16.9007 11.3109 17.0828 11.3863C17.2648 11.4617 17.4599 11.5005 17.657 11.5005C17.854 11.5005 18.0491 11.4617 18.2312 11.3863C18.4132 11.3109 18.5786 11.2004 18.718 11.061C18.8573 10.9217 18.9678 10.7563 19.0432 10.5742C19.1186 10.3922 19.1575 10.1971 19.1575 10C19.1575 9.80299 19.1186 9.60788 19.0432 9.42583C18.9678 9.24378 18.8573 9.07837 18.718 8.93904L13.06 3.28304Z" :fill="fill"/>
    </g>
    <defs>
    <clipPath id="clip0_203_2">
    <rect width="24" height="24" fill="white"/>
    </clipPath>
    </defs>
  </svg>
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none" v-if="name === 'alert'">
    <path d="M11.53 2.29996C11.3955 1.99822 11.1827 1.73799 10.9137 1.54631C10.6446 1.35463 10.3291 1.23849 10 1.20996C9.67267 1.24021 9.35929 1.35714 9.09213 1.54872C8.82497 1.7403 8.61369 1.99961 8.48003 2.29996L0.360027 16.36C-0.479973 17.81 0.210027 19 1.88003 19H18.12C19.79 19 20.48 17.81 19.64 16.36L11.53 2.29996ZM11 16H9.00003V14H11V16ZM11 12H9.00003V5.99996H11V12Z" :fill="fill"/>
  </svg>
</template>
<script>
export default {
  props: {
    name: String,
    fill: { default: "#000", type: String },
  },
};
</script>
